
import ChatInput from 'components/chat-input-v2'

export default {
  components: {ChatInput},
  props: {
    chatId: {type: String, default: ''},
    history: {type: Array, default: () => []},
    generating: {type: Boolean, default: false},
    loading: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false}
  },
  emits: ['regenerate', 'stop', 'resize'],
  data() {
    return {
      input_text: ''
    }
  },
  computed: {
    last_answer() {
      return this.history.findLast(item => item.type === 'assistant')
    },
    ai_question() {
      if (this.loading) return undefined
      return this.last_answer?.data?.question
    },
  },
  mounted() {
    if (this.history.length <= 1 || this.$responsive.mobile || this.generating || this.history.at(-1)?.intermediate) return
    this.focus()
  },
  methods: {
    focus() {
      if (this.readonly) return
      this.$refs.input?.focus()
    },
    onStop() {
      this.$emit('stop')
    }
  }
}
